import { InvestmentType } from '../types/stocks';

// Map enum names to user-friendly labels if needed
const friendlyMap: Record<string,string> = {
  Stock: 'Ação',
  ETF: 'ETF',
  Bond: 'Obrigação',
  MutualFund: 'Fundo',
  Cryptocurrency: 'Cripto',
  RealEstate: 'Imobiliário',
  Commodity: 'Matéria-prima'
};

export function investmentTypeToLabel(type: InvestmentType | undefined, symbol?: string): string {
  if (type !== undefined && type !== null && typeof type === 'number') {
    const enumName = (InvestmentType as any)[type];
    if (typeof enumName === 'string') {
      return friendlyMap[enumName] || enumName;
    }
  }
  if (symbol) {
    const upper = symbol.toUpperCase();
    if (["SPY","QQQ","IWM","VTI","VOO"].includes(upper) || upper.includes('ETF')) return 'ETF';
  }
  return 'Ação';
}

export function isCrypto(type: InvestmentType | undefined): boolean {
  return type === InvestmentType.Cryptocurrency;
}
